<template>
	<div class="user-sidebar">
    <div class="sidebar-nav">
      <router-link to="/search" class="sidebar-link">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C4.03672 0 0 4.03672 0 9C0 13.9633 4.03692 18 9.00021 18C10.6999 17.9997 12.358 17.5156 13.7842 16.6134L18.293 21.1222L21.1212 18.294L16.6125 13.7853C17.5152 12.3589 17.9996 10.7002 18 9C18 4.03672 13.9633 0 9 0ZM4 9C4 6.24328 6.24328 4 9 4C11.7567 4 14 6.24328 14 9C14 11.7567 11.7567 14 9 14C6.24328 14 4 11.7567 4 9Z" fill="#858585"/>
        </svg>
        <p>Search</p>
    </router-link>
    <router-link to="/saved" class="sidebar-link">
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.6667 21C19.2855 21 19.879 20.7542 20.3166 20.3166C20.7542 19.879 21 19.2855 21 18.6667V2.33333C21 1.71449 20.7542 1.121 20.3166 0.683417C19.879 0.245833 19.2855 0 18.6667 0H2.33333C1.71449 0 1.121 0.245833 0.683417 0.683417C0.245833 1.121 0 1.71449 0 2.33333V18.6667C0 19.2855 0.245833 19.879 0.683417 20.3166C1.121 20.7542 1.71449 21 2.33333 21H18.6667ZM9.33333 10.5V4.66667H11.6667V10.5H16.3333L10.5 16.3333L4.66667 10.5H9.33333Z" fill="#858585"/>
        </svg>
        <p>Saved Searches</p>
    </router-link>
    <router-link to="/expiry-alerts" class="sidebar-link">
        <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.307 1.20005C11.615 0.666715 12.3848 0.666716 12.6927 1.20005L23.4314 19.8C23.7393 20.3334 23.3544 21 22.7386 21H1.26115C0.645314 21 0.260414 20.3334 0.568334 19.8L11.307 1.20005ZM10.3846 15.077H13.6154V18.3077H10.3846V15.077ZM14.1533 7.5385H9.84557L10.384 14H13.6148L14.1533 7.5385Z" fill="#858585"/>
        </svg>
        <p>Expiry Alerts</p>
    </router-link>
    </div>
		<div class="statistics">
      <div class="item">
        <!-- <span v-if='currentUser.remainingSearches==0 && currentUser.tier=="FOUNDER"'>Infinite</span> -->
        <span>{{currentUser.searchesPerformed}}</span>
        <p>Searches Performed</p>
      </div>
        <div class="item" @click="feedbackTab" style="cursor:pointer;">
          <span style="color:black;">{{currentUser.feedbacksGiven}}</span>
            <p>Feedback Given</p>
        </div>
    </div>
    <div class="user-actions">
      <a href='http://www.asiaactual.com' target='_blank' class="sidebar-logo">
        <img :src="src[currentSrc]" alt="Asia Actual Logo"/>
      </a>
      <button class="toggle-sidebar" v-on:click="toggleSidebar">
        <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.046875" width="4" height="21" fill="#858585"/>
          <rect x="8.04688" width="13" height="21" fill="#858585"/>
        </svg>
        <p>Toggle Sidebar</p>
      </button>
      <Logout-button v-if='user'/>
    </div>
	</div>
</template>

<script>
import LogoutButton from '@/components/shared/buttons/LogoutButton.vue';
import ShrinkLogo from '@/assets/images/common/logo-shrink.png';
import FullLogo from '@/assets/images/common/asia-logo.svg';

import * as isUserLoggedIn from '@/store/isUserLoggedIn';
import {axiosClient} from "@/axios-client";

export default {
  name: 'sidebar',
  components: {
    LogoutButton
  },

  props: ['currentUser'],

  data: function() {
    return {
      src:[FullLogo, ShrinkLogo],
      currentSrc: 0,
      user: isUserLoggedIn.isUserLoggedIn(),
      // currentUser: {}
    }
  },

  mounted() {
    axiosClient.get('v1/account')
      .then((response) => {
        this.currentUser = response.data;
    });
  },

  // updated() {
  //   axiosClient.get('v1/account')
  //     .then((response) => {
  //       this.currentUser = response.data;
  //   })
    
  // },

  methods: {
    feedbackTab(e){
      let routeData = this.$router.resolve({name: 'account', query: {data: "feedback"}});
      window.open(routeData.href, '_blank');
    },
    toggleSidebar(e) {
      e.stopPropagation();
      let sidebar = document.querySelector('.user-sidebar');
      sidebar.classList.toggle('shrink-sidebar');

      if(this.currentSrc < this.src.length-1){
        this.currentSrc ++
      }else{
        this.currentSrc = 0
      }
    }
  },
}

</script>


<style lang="scss">
	.user-sidebar {
    width: 265px;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // transition: 0.2s;
    
    .sidebar-link {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 27px 0 27px 40px;

      &.router-link-active{
        border-right: 6px solid #FCAF05;
        background: #f9f9f9;

        svg {
          path {
            fill: #FCAF05;
          }
        }

        p {
          color: #FCAF05;
        }
      }

      &:hover {
        // border-right: 6px solid #FCAF05;
        background: #f9f9f9;

        svg {
          path {
            fill: #FCAF05;
          }
        }

        p {
          color: #FCAF05;
        }
      }

      &.active-link {
        border-right: 6px solid #FCAF05;
        background: #F9F9F9;

        svg path {
          fill: #FCAF05;
        }

        p {
          color: #FCAF05;
        }
      }

      svg {
        margin-right: 20px;
      }

      p {
        margin: 0;
        color: #858585;
      }
    }

    .statistics {
      width: 70%;
      margin: 50px auto;
      background: #f9f9f9;
      border: 1px solid #E2E2E2;
      border-radius: 15px;
      // transition: 0.2s;
      
      .feedback-link{
        display: block;
        .item{
            border-top: 1px solid #ededed !important;
        }
      }

      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 110px;
        border-bottom: 1px solid #ededed;

        &:last-of-type {
          border: none;
        }

        span {
          font-family: "Gotham-Medium";
          font-size: 26px;
          line-height: 25px;
          min-height: 30px;
        }

        p {
          text-align: center;
          width: 70%;
          font-size: 14px;
          line-height: 22px;
          color: #858585;
          margin: 7px 0 0 0;
        }
      }
    }

    .user-actions {
      display: flex;
      flex-direction: column;

      .sidebar-logo {
        margin: 0 auto 13px auto;
      }

      .toggle-sidebar {
        display: flex;
        align-items: center;
        padding: 27px 0 27px 40px;
        border: none;
        background: none;
        border-bottom: 1px solid #E2E2E2;

        &:focus {
          outline: none;
        }

        svg {
          margin-right: 20px;
        }

        p {
          margin: 0;
          color: #858585;
        }
      }
    }

    &.shrink-sidebar {
      width: 116px;

      .sidebar-nav {
        .sidebar-link {
          p {
            display: none;
          }
        }
      }

      a {
        padding: 27px 0;
        justify-content: center;

        svg {
          margin: 0;
        }
      }

      .statistics {
        width: 100%;
        border-radius: 0;
      }

      .user-actions {
        .toggle-sidebar {
          p {
            display: none;
          }
        }

        .logout-btn-wrap {
          p {
            display: none;
          }
        }
      }
    }
  }
</style>